<template>
    <div class="td-g">
        <div class="bg-menu">
            <div class="td-container">
                <div class="link-item" v-for="(item, index) in headMenu" :key="index">
                    <div class="link-btn" @click="headMenuClick(item.path)">
                        <img :src="item.img"/>
                        <div>{{item.title}}</div>
                    </div>
                </div>
            </div>
        </div>
        <el-row type="flex" class="td-container td-fcc menu-box">
            <el-col :lg="4" :md="24" class="hidden-md-and-down">
                <div class="logo">
                    <img src="../../assets/img/logo.png" alt="">
                </div>
            </el-col>
            <el-col :lg="20" :md="24">
                <el-row>
                    <el-col :md="4" :sm="4" :xs="8" v-for="(item, index) in topMenu" :key="index">
                        <div class="menu-item" @click="golink(item.path,index)">
                            <img class="left-icon" :src="item.img">
                            <div class="right-text">
                                <div>
                                    <div class="active-color"
                                         :class="[menuIndex==index?'active-item':'',item.color]"></div>
                                    <div>{{item.title}}</div>
                                </div>
                                <div>{{item.desc}}</div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import selectCourse from "@/components/common/selectCourse";
    import soundCourse from "@/components/common/soundCourse";

    export default {
        name: "topHeader",
        props: {
            type: {
                type: String,
                default: "word"
            }
        },
        data() {
            return {
                headMenu: [],
                topMenu: [],
                headMenuWord: [
                    {
                        name: "home",
                        title: "首页",
                        icon: "head_icon.png",
                        path: "home"
                    },
                    // {
                    //     name: "word",
                    //     title: "学习中心",
                    //     icon: "head_icon2.png",
                    //     path: "word"
                    // },
                    {
                        name: "course",
                        title: "课程中心",
                        icon: "head_icon2.png",
                        path: "course"
                    },
                    {
                        name: "user",
                        title: "用户中心",
                        icon: "head_icon3.png",
                        path: "user"
                    },
                    {
                        name: "ranking",
                        title: "努力榜",
                        icon: "head_icon4.png",
                        path: "ranking"
                    },
                    // {
                    //     name: "download",
                    //     title: "下载中心",
                    //     icon: "head_icon5.png",
                    //     path: "download"
                    // },
                    {
                        name: "help",
                        title: "帮助",
                        icon: "head_icon6.png",
                        path: "helpUs"
                    },
                    {
                        name: "quit",
                        title: "退出",
                        icon: "head_icon7.png",
                        path: "quit"
                    }
                ],
                topMenuWord: [
                    {
                        title: "单词基础",
                        desc: "智能听写",
                        icon: "menu_item1.png",
                        path: "/word",
                        color: "color1"
                    },
                    {
                        title: "记忆曲线",
                        desc: "智能复习",
                        icon: "menu_item2.png",
                        path: "/word/memoryCurve",
                        color: "color2"
                    },
                    {
                        title: "单词量测试",
                        desc: "词汇测试",
                        icon: "menu_item3.png",
                        path: "/word/wordExam",
                        color: "color3"
                    },
                    {
                        title: "学习报告",
                        desc: "数据统计",
                        icon: "menu_item4.png",
                        path: "/word/learnData",
                        color: "color4"
                    },
                    {
                        title: "生词本",
                        desc: "我的单词",
                        icon: "menu_item5.png",
                        path: "/word/new_word",
                        color: "color5"
                    },
                    {
                        title: "个人设置",
                        desc: "设置中心",
                        icon: "menu_item6.png",
                        path: "/word/setting",
                        color: "color6"
                    }
                ],
                headMenuGrammar: [
                    {
                        name: "home",
                        title: "首页",
                        icon: "head_icon.png",
                        path: "home"
                    },
                    {
                        name: "grammar",
                        title: "学习中心",
                        icon: "head_icon2.png",
                        path: "grammar"
                    },
                    {
                        name: "course",
                        title: "课程中心",
                        icon: "head_icon2.png",
                        path: "course"
                    },
                    {
                        name: "user",
                        title: "用户中心",
                        icon: "head_icon3.png",
                        path: "user"
                    },
                    {
                        name: "ranking",
                        title: "努力榜",
                        icon: "head_icon4.png",
                        path: "ranking"
                    },
                    // {
                    //     name: "download",
                    //     title: "下载中心",
                    //     icon: "head_icon5.png",
                    //     path: "download"
                    // },
                    {
                        name: "help",
                        title: "帮助",
                        icon: "head_icon6.png",
                        path: "helpUs"
                    },
                    {
                        name: "quit",
                        title: "退出",
                        icon: "head_icon7.png",
                        path: "quit"
                    }
                ],
                topMenuGrammar: [
                    {
                        title: "语法基础",
                        desc: "智能听写",
                        icon: "menu_item1.png",
                        path: "/grammar",
                        color: "color1"
                    },
                    {
                        title: "记忆曲线",
                        desc: "智能复习",
                        icon: "menu_item2.png",
                        path: "/grammar/memoryCurve",
                        color: "color2"
                    },
                    {
                        title: "语法量测试",
                        desc: "词汇测试",
                        icon: "menu_item3.png",
                        path: "/grammar/grammarExam?type=yufa&resd=fdfd",
                        color: "color3"
                    },
                    {
                        title: "学习报告",
                        desc: "数据统计",
                        icon: "menu_item4.png",
                        path: "/grammar/learnData",
                        color: "color4"
                    },
                    {
                        title: "语法本",
                        desc: "我的语法本",
                        icon: "menu_item5.png",
                        path: "/grammar/newGrammar",
                        color: "color5"
                    },
                    {
                        title: "个人设置",
                        desc: "设置中心",
                        icon: "menu_item6.png",
                        path: "/grammar/setting",
                        color: "color6"
                    }
                ],
                headMenuSound: [
                    {
                        name: "home",
                        title: "首页",
                        icon: "head_icon.png",
                        path: "home"
                    },
                    {
                        name: "grammar",
                        title: "学习中心",
                        icon: "head_icon2.png",
                        path: "grammar"
                    },
                    {
                        name: "course",
                        title: "课程中心",
                        icon: "head_icon2.png",
                        path: "soundCourse"
                    },
                    {
                        name: "user",
                        title: "用户中心",
                        icon: "head_icon3.png",
                        path: "user"
                    },
                    // {
                    //     name: "ranking",
                    //     title: "努力榜",
                    //     icon: "head_icon4.png",
                    //     path: "ranking"
                    // },
                    // {
                    //     name: "download",
                    //     title: "下载中心",
                    //     icon: "head_icon5.png",
                    //     path: "download"
                    // },
                    {
                        name: "help",
                        title: "帮助",
                        icon: "head_icon6.png",
                        path: "helpUs"
                    },
                    {
                        name: "quit",
                        title: "退出",
                        icon: "head_icon7.png",
                        path: "quit"
                    }
                ],
                topMenuSound: [
                    {
                        title: "个人设置",
                        desc: "设置中心",
                        icon: "menu_item6.png",
                        path: "/soundmark/setting",
                        color: "color6"
                    }
                ],
                menuIndex: "",
            };
        },
        methods: {
            // head menu click
            headMenuClick(path) {
                if (path == "course") {
                    this.getCourse();
                } else if (path == "soundCourse") {
                    this.getCourse();
                } else if (path == "ranking") {
                    this.$router.push({
                        path: "/" + path,
                        query: {
                            type: this.type
                        }
                    });
                } else if (path == "quit") {
                    this.signOut();
                } else {
                    this.$router.push("/" + path);
                }
            },
            golink(url, index) {
                this.menuIndex = index;
                this.$router.push(url);
            },
            //打开课程中心
            getCourse() {
                this.DialogResult({
                    component: selectCourse,
                    data: {
                        source: {
                            type: this.type,
                            target: 'courseCenter',
                        }
                    },
                    callback: (res) => {
                        this.$emit('callback', res)
                    }
                })
            },
            getSoundCourse(){
                this.DialogResult({
                    component: soundCourse,
                    data: {
                        source: {
                            type: this.type,
                            target: 'courseCenter',
                        }
                    },
                    callback: (res) => {
                        this.$emit('callback', res)
                    }
                })
            },
            //退出登录
            signOut() {
                this.$confirm("您将要退出当前账户？", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$store
                        .dispatch("LogOut", {})
                        .then(res => {
                            this.$router.replace("/login");
                        })
                        .catch(err => {
                            this.$message.error({
                                message: err.msg,
                                duration: "2000"
                            });
                        });
                }).catch(() => {
                });
            }
        },
        watch: {
            $route() {
                if (this.type == "word") {
                    this.headMenu = this.headMenuWord;
                    this.topMenu = this.topMenuWord;
                } else if (this.type == "grammar") {
                    this.headMenu = this.headMenuGrammar;
                    this.topMenu = this.topMenuGrammar;
                } else if (this.type == "soundmark") {
                    this.headMenu = this.headMenuSound;
                    this.topMenu = this.topMenuSound;
                }
            },
        },
        created() {
            this.headMenuWord.map((item, index) => {
                this.headMenuWord[index].img = require("@/assets/img/topHeader/" + item.icon);
            });
            this.headMenuGrammar.map((item, index) => {
                this.headMenuGrammar[index].img = require("@/assets/img/topHeader/" + item.icon);
            });
            this.headMenuSound.map((item, index) => {
                this.headMenuSound[index].img = require("@/assets/img/topHeader/" + item.icon);
            });
            this.topMenuGrammar.map((item, index) => {
                this.topMenuGrammar[index].img = require("@/assets/img/topHeader/" + item.icon);
            });
            this.topMenuWord.map((item, index) => {
                this.topMenuWord[index].img = require("@/assets/img/topHeader/" + item.icon);
            });
            this.topMenuSound.map((item, index) => {
                this.topMenuSound[index].img = require("@/assets/img/topHeader/" + item.icon);
            });
            if (this.type == "word") {
                this.headMenu = this.headMenuWord;
                this.topMenu = this.topMenuWord;
            } else if (this.type == "grammar") {
                this.headMenu = this.headMenuGrammar;
                this.topMenu = this.topMenuGrammar;
            } else if (this.type == "soundmark") {
                this.headMenu = this.headMenuSound;
                this.topMenu = this.topMenuSound;
            }
        }
    };
</script>

<style scoped lang='less'>
    .top-logo {
        padding: 10px 0;

        img {
            display: block;
            height: 30px;
        }
    }

    .link-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
        padding: 20px 0;
        transition: all 0.5s;
        cursor: pointer;

        > div {
            white-space: nowrap;
        }

        img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
        }
    }

    .link-btn:hover {
        color: #469ff3;
    }

    .logo {
        img {
            height: 40px;
        }
    }

    .menu-box {
        padding: 14px 0;
    }

    .menu-item {
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .left-icon {
            width: 36px;
            height: 36px;
            margin-right: 10px;
        }

        .right-text {
            font-size: 14px;
            color: #444;
            width: 120px;

            > div:nth-of-type(1) {
                display: flex;
                font-size: 16px;
                align-items: center;

                .active-color {
                    width: 6px;
                    height: 16px;
                    border-radius: 3px;
                    margin-right: 4px;
                    transition: all 0.2s;
                }
            }

            > div:nth-of-type(2) {
                font-size: 13px;
                text-align: right;
                margin-top: 5px;
            }
        }
    }
   .link-item{
       display: inline-block;
       padding: 0 20px;
   }
    .menu-item:hover {
        .right-text {
            > div:nth-of-type(1) {
                .active-color {
                    width: 15px;
                }
            }
        }
    }

    .active-item {
        width: 25px !important;
    }

    @media (max-width: 992px) {
        .link-btn {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 14px;

            img {
                margin-right: 0;
                margin-bottom: 6px;
            }
        }

        .menu-item {
            .right-text {
                > div:nth-of-type(2) {
                    text-align: left;
                    padding-left: 10px;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .link-btn {
            font-size: 12px;
        }
    }
    @media (min-width: 1200px) {
        .link-btn {
            font-size: 18px;
        }
    }
    @media (min-width: 1600px) {
        .menu-box {
            padding: 22px 0;
        }
    }
</style>